// src/svg/SVGNoFilterResults.tsx
import React from "react";
var SVGNoFilterResults = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    id: "no-filter-results_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 1019.8 988.1",
    ...props
  },
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("style", null, ".no-filter-results_svg__cls-5{fill:#b3a9fc}.no-filter-results_svg__cls-6{fill:#fff}.no-filter-results_svg__cls-7{fill:#e9e9ff}")),
  /* @__PURE__ */ React.createElement("circle", { cx: 506.25, cy: 500.56, r: 435.48, fill: "#f8f8ff" }),
  /* @__PURE__ */ React.createElement("circle", { cx: 506.25, cy: 500.56, r: 313.69, fill: "#f0f0ff" }),
  /* @__PURE__ */ React.createElement(
    "circle",
    {
      cx: 599.81,
      cy: 189.1,
      r: 19.3,
      strokeWidth: 11,
      fill: "none",
      stroke: "#b3a9fc",
      strokeMiterlimit: 10
    }
  ),
  /* @__PURE__ */ React.createElement(
    "circle",
    {
      cx: 118.31,
      cy: 415.4,
      r: 13.4,
      strokeWidth: 9,
      fill: "none",
      stroke: "#b3a9fc",
      strokeMiterlimit: 10
    }
  ),
  /* @__PURE__ */ React.createElement(
    "circle",
    {
      className: "no-filter-results_svg__cls-5",
      cx: 204.01,
      cy: 592.7,
      r: 10.1
    }
  ),
  /* @__PURE__ */ React.createElement(
    "circle",
    {
      className: "no-filter-results_svg__cls-5",
      cx: 379.21,
      cy: 117.7,
      r: 10.1
    }
  ),
  /* @__PURE__ */ React.createElement(
    "circle",
    {
      className: "no-filter-results_svg__cls-5",
      cx: 880.31,
      cy: 368.4,
      r: 10.1
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      className: "no-filter-results_svg__cls-5",
      d: "M832.71 505.7l4.8-4.8a7.67 7.67 0 000-10.7 7.57 7.57 0 00-10.7 0L822 495l-4.8-4.8a7.57 7.57 0 10-10.7 10.7l4.8 4.8-4.8 4.8a7.57 7.57 0 0010.7 10.7l4.8-4.8 4.8 4.8a7.57 7.57 0 0010.7-10.7zm-534.5-146.4h4.3a4.8 4.8 0 000-9.6h-4.3v-4.3a4.8 4.8 0 00-9.6 0v4.3h-4.3a4.8 4.8 0 100 9.6h4.3v4.3a4.8 4.8 0 109.6 0z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      className: "no-filter-results_svg__cls-6",
      d: "M730.23 433l-220-32.13L288.22 433c2.37 2.38 174.13 249.52 174.13 249.52V835.9l93.75-57.33v-96z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      className: "no-filter-results_svg__cls-7",
      d: "M288.22 433h412.65L526.74 682.55v96L462.35 818v17.9l93.75-57.33v-96L730.23 433z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      className: "no-filter-results_svg__cls-6",
      d: "M462.35 835.9l93.75-57.33v-96h-93.75z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      className: "no-filter-results_svg__cls-7",
      d: "M526.74 682.55v96L462.35 818v17.9l93.75-57.33v-96z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      className: "no-filter-results_svg__cls-6",
      d: "M732.31 432.84H286.14A19.89 19.89 0 01266.25 413v-43.59a19.9 19.9 0 0119.89-19.89h446.17a19.9 19.9 0 0119.89 19.89V413a19.89 19.89 0 01-19.89 19.84z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      className: "no-filter-results_svg__cls-7",
      d: "M732.31 349.52H703a19.9 19.9 0 0119.89 19.89V413A19.89 19.89 0 01703 432.84h29.36A19.89 19.89 0 00752.2 413v-43.59a19.9 19.9 0 00-19.89-19.89z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M462.46 842.22a6.41 6.41 0 01-6.46-6.32V684.53l-.18-.26c-52.42-75.42-155.55-223.63-170.68-244.74l-.28-.38h-.47A26.29 26.29 0 01259.91 413v-43.59a26.26 26.26 0 0126.23-26.23h38.4c4.2 0 6.11 3.29 6.11 6.34s-1.91 6.34-6.11 6.34h-38.4a13.57 13.57 0 00-13.55 13.55V413a13.56 13.56 0 0013.55 13.55h446.17A13.56 13.56 0 00745.86 413v-43.59a13.57 13.57 0 00-13.55-13.55h-355c-4.2 0-6.11-3.29-6.11-6.34s1.91-6.34 6.11-6.34h355a26.26 26.26 0 0126.23 26.23V413a26.31 26.31 0 01-24.37 26.16h-.48l-73.12 104.77a5.71 5.71 0 01-4.81 2.67 7.23 7.23 0 01-6.13-3.79 5.72 5.72 0 01.54-6.14l67.9-97.3H300.52l1.11 1.57c20.37 28.84 75.48 107.85 163.74 234.84l.3.43h48.45c4.2 0 6.11 3.28 6.11 6.34a6.7 6.7 0 01-1.53 4.39 5.84 5.84 0 01-4.58 1.94h-45.43v135.71L549.76 775v-92.45a6.28 6.28 0 011.14-3.63l73.6-105.47a5.69 5.69 0 014.8-2.67 7.21 7.21 0 016.13 3.79 5.7 5.7 0 01-.53 6.14l-72.46 103.83v94a6.4 6.4 0 01-3 5.41l-93.74 57.33a6.11 6.11 0 01-3.24.94z",
      fill: "#060606"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M437.31 521.07c0-13.2-13.4-23.9-30-23.9s-30 10.7-30 23.9 13.4 23.9 30 23.9 30-10.8 30-23.9zm198 0c0-13.2-13.4-23.9-30-23.9s-30 10.7-30 23.9 13.4 23.9 30 23.9 30-10.8 30-23.9z",
      fill: "#d1d1ed"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { d: "M541.51 531.07a5.55 5.55 0 01-5.5-5.5c-.1-1.7-1.7-15.8-30-15.8s-29.9 14.3-30 15.9a5.22 5.22 0 01-1.7 3.9 5.43 5.43 0 01-3.6 1.4h-.3a5.44 5.44 0 01-5.4-5.4c0-1.1.8-26.8 41-26.8s40.9 25.7 40.9 26.8a5.46 5.46 0 01-5.4 5.5zm-142-7.07a6.75 6.75 0 01-1.4-.2 5.45 5.45 0 01-2.4-9.2l7.1-7.1a5.37 5.37 0 013.8-1.5 5.7 5.7 0 013.9 1.6 5.59 5.59 0 01.1 7.7l-7.1 7.1a6.14 6.14 0 01-4 1.6zm28.4 0a6.75 6.75 0 01-1.4-.2 5.45 5.45 0 01-2.4-9.2l7.1-7.1A5.37 5.37 0 01435 506a5.7 5.7 0 013.9 1.6 5.59 5.59 0 01.1 7.7l-7.1 7.1a6.14 6.14 0 01-4 1.6zm184.4-.13a5.37 5.37 0 01-3.8-1.5l-7.1-7.1a5.46 5.46 0 01.1-7.6 5.52 5.52 0 013.9-1.6 5.37 5.37 0 013.8 1.5l7.1 7.1a5.46 5.46 0 01-.1 7.6 5.52 5.52 0 01-3.9 1.6zm-28.31 0a5.37 5.37 0 01-3.8-1.5l-7.1-7.1a5.46 5.46 0 01.1-7.6 5.52 5.52 0 013.9-1.6 5.37 5.37 0 013.8 1.5l7.1 7.1a5.46 5.46 0 01-.1 7.6 5.89 5.89 0 01-3.9 1.6zM372.54 420.26l-.18-.28-15.36-21.5a6.3 6.3 0 00-10.15 0l-15.38 21.54-.2.31a21.83 21.83 0 00.14 21.92 23.59 23.59 0 0041 0 21.76 21.76 0 00.1-22.05zm-8.37 17.24a14.09 14.09 0 01-7.39 6.25 14 14 0 01-9.68 0 14.1 14.1 0 01-7.42-6.29 12.17 12.17 0 01-.26-12.06l12.52-17.53 12.47 17.46a12.12 12.12 0 01-.24 12.17z" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      className: "no-filter-results_svg__cls-7",
      d: "M365.93 431.39a12.23 12.23 0 01-1.76 6.11 14.09 14.09 0 01-7.39 6.25 14 14 0 01-9.68 0 14.1 14.1 0 01-7.42-6.29 12.17 12.17 0 01-.26-12.06l12.52-17.53 12.47 17.46a12.18 12.18 0 011.52 6.06z"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { d: "M448.36 468.31l-16.91-7.42a6.7 6.7 0 00-5.35 12.27l2.9 1.28-2.9 1.28a6.7 6.7 0 005.36 12.28l16.91-7.43a6.7 6.7 0 000-12.27zm115.91 12.26l16.9 7.42a6.7 6.7 0 005.36-12.27l-2.91-1.29 2.91-1.27a6.7 6.7 0 00-5.36-12.27l-16.9 7.42a6.7 6.7 0 000 12.27z" })
);

export {
  SVGNoFilterResults
};
